import { render, staticRenderFns } from "./trocaire.vue?vue&type=template&id=e5ad7aee&"
import script from "./trocaire.vue?vue&type=script&lang=js&"
export * from "./trocaire.vue?vue&type=script&lang=js&"
import style0 from "./trocaire.vue?vue&type=style&index=0&media=screen&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports